import { useState } from "react";
import CheckinReport from "./reports/CheckinReport";
import FirstVisitsReport from "./reports/FirstVisitsReport";
import AttendanceReport from "./reports/AttendanceReport";
import PayrollReport from "./reports/PayrollReport";
import MonthlyRevenueReport from "./reports/MonthlyRevenueReport";
import WorkshopRevenueReport from "./reports/WorkshopRevenueReport";
import MerchReport from "./reports/MerchReport";
import WaiverReport from "./reports/WaiverReport";
import RevenueReport from "./reports/RevenueReport";
import PassAlertsReport from "./reports/PassAlertsReport";
import VideoRentalsReport from "./reports/VideoRentalsReport";
import "../admin-base.css";
import "../admin-layout.css";
import "../admin-controls.css";
import "../admin-students.css";
import "../admin-misc.css";
import "../admin-responsive.css";
import "./reportsTab.css";

const REPORT_OPTIONS = [
  { id: "checkin",           label: "R1 — Check-in" },
  { id: "first-visits",      label: "R2 — First Visits" },
  { id: "attendance",        label: "R3 — Attendance" },
  { id: "payroll",           label: "R4 — Payroll" },
  { id: "monthly-revenue",   label: "R5 — Monthly Revenue" },
  { id: "workshop-revenue",  label: "R6 — Workshop Revenue" },
  { id: "merch",             label: "R7 — Merch Sales" },
  { id: "waivers",           label: "R8 — Waivers" },
  { id: "revenue",           label: "R9 — Revenue (14-day)" },
  { id: "pass-alerts",       label: "R10 — Pass Alerts" },
  { id: "video-rentals",     label: "R11 — Video Rentals" },
];

export default function ReportsTab() {
  const [activeReport, setActiveReport] = useState("checkin");

  const reportComponent = () => {
    switch (activeReport) {
      case "checkin":          return <CheckinReport />;
      case "first-visits":     return <FirstVisitsReport />;
      case "attendance":       return <AttendanceReport />;
      case "payroll":          return <PayrollReport />;
      case "monthly-revenue":  return <MonthlyRevenueReport />;
      case "workshop-revenue": return <WorkshopRevenueReport />;
      case "merch":            return <MerchReport />;
      case "waivers":          return <WaiverReport />;
      case "revenue":          return <RevenueReport />;
      case "pass-alerts":      return <PassAlertsReport />;
      case "video-rentals":    return <VideoRentalsReport />;
      default:                 return null;
    }
  };

  return (
    <div className="adm-tab-content adm-reports">
      <div className="adm-report-selector">
        <label className="adm-filter-label">Report</label>
        <select className="adm-input adm-report-dropdown" value={activeReport} onChange={e => setActiveReport(e.target.value)}>
          {REPORT_OPTIONS.map(r => <option key={r.id} value={r.id}>{r.label}</option>)}
        </select>
      </div>
      <div className="adm-report-body">
        {reportComponent()}
      </div>
    </div>
  );
}
